export const AMAP_API_KEY = 'C3iM1kcytvSFKNeYye2Ld8B56ZaRagjI';